import { getLocalStorageItem } from "../storage_utils";
import { AppCaregiver } from "../system/AppState/AppCaregiverState";
import { AppVersion } from "../version";

let isInitialized = false;

async function init() {
  if (!import.meta.env.PROD) {
    console.log(`[analytics] ignoring init in dev`);
    return;
  }

  console.log(`[analytics] init`);

  const { default: LogRocket } = await import("logrocket");

  LogRocket.init("qlu1lh/onboarding-production");

  isInitialized = true;
}

async function track(trackingEvent: string) {
  if (!import.meta.env.PROD) {
    console.log(`[analytics] ignoring track in dev`);
    return;
  }

  console.log(`[analytics] track`);

  const { default: LogRocket } = await import("logrocket");

  LogRocket.track(trackingEvent);
}

async function initAndIdentifyCaregiver(params: {
  caregiver: Pick<AppCaregiver, "id" | "phoneNumbers">;
}) {
  if (!import.meta.env.PROD) {
    console.log(`[analytics] ignoring initAndIdentifyCaregiver in dev`);
    return;
  }

  console.log(`[analytics] initAndIdentifyCaregiver`);

  const { default: LogRocket } = await import("logrocket");
  const { default: setupLogRocketReact } = await import("logrocket-react");
  const language = (await getLocalStorageItem("medflyt_language_override")) ?? "en";

  if (!isInitialized) {
    await init();
  }

  const id = `caregiver:${params.caregiver.id}`;
  const traits = {
    caregiverId: params.caregiver.id.toString(),
    phoneNumbers: params.caregiver.phoneNumbers
      .map((phoneNumber) => phoneNumber.phoneNumber)
      .join(", "),
    mobileLanguage: language,
    navigatorLanguage: navigator.language,
    appVersion: AppVersion,
  };

  LogRocket.identify(id, traits);

  setupLogRocketReact(LogRocket);
}

export default {
  init: init,
  initAndIdentifyCaregiver: initAndIdentifyCaregiver,
  track: track,
};
